import { sliceAddressForDisplay } from '@utils/common'
import { Hex } from 'viem'
import { useEnsName } from 'wagmi'

/**
 * Displays an Ethereum address.
 * Shows the ENS name if available, otherwise displays a sliced version of the address
 * using `sliceAddressForDisplay` (e.g., `0x123...abcd`).
 *
 * @param address The Ethereum address to display.
 * @returns A React node containing the formatted address or null if the address is null/undefined.
 */
export function AddressDisplay({ address }: { address?: Hex | null }): React.ReactNode {
  let display = sliceAddressForDisplay(address ?? '')

  const { data: ensName } = useEnsName({ address: address ?? undefined })
  if (ensName) {
    display = ensName
  }

  return display ?? null
}
